import React, { HTMLProps, ReactNode } from 'react';
import CheckInput, { InputType } from '../../../../../atoms/CheckInput';
import * as IBooks from '../../../../../interfaces/merchants/resources/books';
import PaymentText from '../PaymentText';

import css from './BooksPaymentMethods.module.scss';

interface Props extends HTMLProps<{}> {
  onChange: (e: React.ChangeEvent) => void;
  payments: IBooks.PaymentMethod[];
  selectedMethod?: IBooks.PaymentMethod['method'];
  subComponents: {
    credit_card: ReactNode;
    ticket: ReactNode;
    subscription: ReactNode;
  };
}

const isDisablePayment = (payment: IBooks.PaymentMethod) => {
  const errors = payment.disabled_reasons
    ? payment.disabled_reasons.filter(
        (r) =>
          r !== IBooks.DisabledReason.NoProducts &&
          r !== IBooks.DisabledReason.LimitExceeded,
      )
    : [];
  if (
    payment.method === 'credit_card' ||
    payment.method === 'bank_transfer' ||
    payment.method === 'onsite'
  ) {
    return !payment.available;
  } else if (payment.method === 'ticket' || payment.method === 'subscription') {
    return errors.length > 0;
  } else {
    return false;
  }
};

const BooksPaymentMethods = ({
  onChange,
  payments,
  selectedMethod,
  subComponents,
}: Props) => {
  const creditCardPayment = payments.find((p) => p.method === 'credit_card');
  const otherPayments = payments.filter((p) => p.method !== 'credit_card');

  const resolvedCreditCardSubComponent =
    creditCardPayment && creditCardPayment.method in subComponents
      ? subComponents[creditCardPayment.method as keyof typeof subComponents]
      : null;

  return (
    <ul className={css.root}>
      {otherPayments.map((payment) => {
        const resolvedSubComponent =
          payment.method in subComponents
            ? subComponents[payment.method as keyof typeof subComponents]
            : null;

        return (
          <li key={payment.method} className={css.payment_item}>
            <CheckInput
              type={InputType.Radio}
              name="payment"
              checked={selectedMethod === payment.method}
              value={payment.method}
              labelPosition="SpaceBetween"
              onChange={onChange}
              disabled={isDisablePayment(payment)}
            >
              <PaymentText payment={payment} />
            </CheckInput>
            {resolvedSubComponent}
          </li>
        );
      })}
      {/* creditCardを最後に表示する */}
      {creditCardPayment && (
        <li>
          <CheckInput
            type={InputType.Radio}
            name="payment"
            checked={selectedMethod === creditCardPayment.method}
            value={creditCardPayment.method}
            labelPosition="SpaceBetween"
            onChange={onChange}
            disabled={!creditCardPayment.available}
          >
            <PaymentText payment={creditCardPayment} />
          </CheckInput>
          {resolvedCreditCardSubComponent}
        </li>
      )}
    </ul>
  );
};

export default BooksPaymentMethods;
